// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/communication.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveConversationRequest, ArchiveConversationResponse, Conversation, CreateConversationRequest, DeleteConversationRequest, DeleteConversationResponse, GetConversationRequest, ListConversationsRequest, ListConversationsResponse, ListMessagesRequest, ListMessagesResponse, Message, SearchMessagesRequest, SearchMessagesResponse, SendEmailReplyRequest, SendEmailReplyResponse, SendMessageRequest, StreamMessagesRequest, UpdateConversationRequest } from "./communication_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.CommunicationService
 */
export const CommunicationService = {
  typeName: "omnios.v1.CommunicationService",
  methods: {
    /**
     * @generated from rpc omnios.v1.CommunicationService.CreateConversation
     */
    createConversation: {
      name: "CreateConversation",
      I: CreateConversationRequest,
      O: Conversation,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.GetConversation
     */
    getConversation: {
      name: "GetConversation",
      I: GetConversationRequest,
      O: Conversation,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.ListConversations
     */
    listConversations: {
      name: "ListConversations",
      I: ListConversationsRequest,
      O: ListConversationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.SendMessage
     */
    sendMessage: {
      name: "SendMessage",
      I: SendMessageRequest,
      O: Message,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.ListMessages
     */
    listMessages: {
      name: "ListMessages",
      I: ListMessagesRequest,
      O: ListMessagesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.StreamMessages
     */
    streamMessages: {
      name: "StreamMessages",
      I: StreamMessagesRequest,
      O: Message,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.UpdateConversation
     */
    updateConversation: {
      name: "UpdateConversation",
      I: UpdateConversationRequest,
      O: Conversation,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.DeleteConversation
     */
    deleteConversation: {
      name: "DeleteConversation",
      I: DeleteConversationRequest,
      O: DeleteConversationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.ArchiveConversation
     */
    archiveConversation: {
      name: "ArchiveConversation",
      I: ArchiveConversationRequest,
      O: ArchiveConversationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.CommunicationService.SendEmailReply
     */
    sendEmailReply: {
      name: "SendEmailReply",
      I: SendEmailReplyRequest,
      O: SendEmailReplyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Full-text search across agent messages
     *
     * @generated from rpc omnios.v1.CommunicationService.SearchMessages
     */
    searchMessages: {
      name: "SearchMessages",
      I: SearchMessagesRequest,
      O: SearchMessagesResponse,
      kind: MethodKind.Unary,
    },
  }
};

